import { ShieldCheck } from "lucide-react";

interface PrivacyReassuranceProps {
  className?: string;
}

const PrivacyReassurance = ({ className = "" }: PrivacyReassuranceProps) => (
  <p className={`flex items-start gap-2 text-xs leading-relaxed text-muted-foreground ${className}`}>
    <ShieldCheck className="mt-0.5 h-4 w-4 flex-shrink-0 text-primary" aria-hidden="true" />
    <span>
      Your information is secure and will remain private. We will never spam you or share your
      information.
    </span>
  </p>
);

export default PrivacyReassurance;
